import { googleMapsApiKey } from "./google-maps.config";

export const environment = {
  production: false,
  environment: "dev",
  kycAadhaarProvider: "cartkyc" as const,
  digilockerRedirectBaseUrl: "https://generic-los-user.katdev.com" as
    string | undefined,
  /** Deployed LOS user API (dev). */
  apiUrl: "https://generic-los-user-api.katdev.com/api/v1",
  googleMapsApiKey,
  appName: "CRM Executive",
  version: "1.0.0",
  logLevel: "info",
  creditBureauClientMockOnApiFailure: true,
  skeletonLoadersEnabled: true,
  sessionIdleTimeoutMs: 30 * 60 * 1000,
  sessionCheckIntervalMs: 30_000,
};
